import { client } from './client';

export function getClassifications() {
  return client('classifications/processed', { method: 'GET' });
}
